import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/mocks/categories";

const CARDS = [
  {
    titleKey: "vp1Title",
    descKey: "vp1Desc",
    ctaKey: "vp1Cta",
    icon: "ri-file-list-3-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20clean%20organized%20digital%20spreadsheet%20grid%20displayed%20on%20a%20laptop%20screen%20with%20a%20coffee%20cup%20and%20a%20notebook%20on%20a%20bright%20minimal%20white%20desk%20beside%20a%20small%20green%20plant%20with%20soft%20natural%20light%20for%20a%20modern%20productivity%20workspace%20scene&width=600&height=400&seq=usfans-vp-spreadsheet&orientation=landscape&nocache=true",
  },
  {
    titleKey: "vp2Title",
    descKey: "vp2Desc",
    ctaKey: "vp2Cta",
    icon: "ri-star-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20close%20up%20of%20a%20five%20star%20rating%20symbol%20with%20gold%20stars%20and%20a%20notepad%20with%20a%20pen%20resting%20on%20a%20warm%20cream%20desk%20surface%20with%20soft%20diffused%20light%20and%20a%20subtle%20shadow%20for%20a%20customer%20review%20concept%20image&width=600&height=400&seq=usfans-vp-review&orientation=landscape&nocache=true",
  },
  {
    titleKey: "vp3Title",
    descKey: "vp3Desc",
    ctaKey: "vp3Cta",
    icon: "ri-truck-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20neat%20cardboard%20shipping%20box%20sealed%20with%20packing%20tape%20and%20a%20small%20brown%20parcel%20sitting%20on%20a%20light%20wooden%20table%20beside%20some%20bubble%20wrap%20with%20soft%20natural%20window%20light%20for%20a%20simple%20ecommerce%20delivery%20concept&width=600&height=400&seq=usfans-vp-shipping&orientation=landscape&nocache=true",
  },
  {
    titleKey: "vp4Title",
    descKey: "vp4Desc",
    ctaKey: "vp4Cta",
    icon: "ri-search-eye-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20magnifying%20glass%20hovering%20over%20a%20clothing%20tag%20and%20a%20fabric%20swatch%20on%20a%20clean%20light%20surface%20with%20a%20clipboard%20nearby%20and%20soft%20studio%20lighting%20for%20a%20product%20quality%20check%20inspection%20concept&width=600&height=400&seq=usfans-vp-qc&orientation=landscape&nocache=true",
  },
  {
    titleKey: "vp5Title",
    descKey: "vp5Desc",
    ctaKey: "vp5Cta",
    icon: "ri-shield-check-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20minimal%20metallic%20shield%20symbol%20resting%20on%20a%20soft%20pastel%20blue%20background%20with%20soft%20diffused%20lighting%20and%20clean%20negative%20space%20for%20a%20simple%20security%20and%20safety%20concept%20image&width=600&height=400&seq=usfans-vp-safety&orientation=landscape&nocache=true",
  },
  {
    titleKey: "vp6Title",
    descKey: "vp6Desc",
    ctaKey: "vp6Cta",
    icon: "ri-archive-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20bright%20organized%20warehouse%20interior%20with%20tall%20metal%20shelving%20rows%20filled%20with%20neatly%20stacked%20cardboard%20boxes%20and%20soft%20ambient%20lighting%20for%20a%20clean%20logistics%20and%20storage%20concept%20image&width=600&height=400&seq=usfans-vp-warehouse&orientation=landscape&nocache=true",
  },
];

export default function ValueProps() {
  const { t } = useTranslation();

  return (
    <section id="spreadsheet" className="w-full bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t("valuePropsH2")}
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-base text-foreground-600">
            {t("valuePropsSub")}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-5">
          {CARDS.map((card) => (
            <a
              key={card.titleKey}
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-white transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="h-40 w-full overflow-hidden bg-background-100">
                <img
                  src={card.image}
                  alt={`${t(card.titleKey)} - USFans Spreadsheet`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                  <i className={`${card.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                  {t(card.titleKey)}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {t(card.descKey)}
                </p>
                <span className="mt-4 inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600">
                  {t(card.ctaKey)}
                  <span className="flex h-4 w-4 items-center justify-center transition-transform group-hover:translate-x-0.5">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}